import { Header, RowData } from "@tanstack/react-table";
import { combineWithPinnedColumnBoxShadow } from "components/Shared/ChakraReactTable/utils";
import type { ComponentProps } from "./index";

function onlyNumber(value: unknown): number | null {
  if (typeof value === "number") return value;
  return null;
}

function getHeaderFooterProps<D extends RowData>(header: Header<D, unknown>) {
  return {
    zIndex: Math.max(
      2,
      header.column.columnDef.meta?.props?.position === "sticky" ||
        header.column.getIsPinned()
        ? 3
        : 0,
      onlyNumber(
        header.column.columnDef.meta?.headerProps?.zIndex ??
          header.column.columnDef.meta?.props?.zIndex,
      ) || 0,
    ),
  };
}

export default function useStickyHeader<D extends RowData>(): Partial<
  ComponentProps<D>
> {
  return {
    tableHeadProps: {
      position: "sticky",
      top: 0,
      zIndex: 2,
    },
    tableFootProps: {
      position: "sticky",
      bottom: 0,
      zIndex: 2,
    },
    getHeaderProps: getHeaderFooterProps,
    getFooterProps: (footer) => ({
      ...getHeaderFooterProps(footer),
      backgroundColor: "inherit",
      borderTopWidth: 0,
      ...combineWithPinnedColumnBoxShadow(
        "inset 0px 1px 0px rgba(0,0,0,.25)",
        "tfoot ",
      ),
    }),
    getFooterGroupProps: () => ({ backgroundColor: "inherit" }),
  };
}
